import { useTranslation } from 'react-i18next';
import type { IBaKindTilesProps } from './IBaKindTilesProps';

/** Тайли видів записів аналізу (прототип v4 bdKpis): підпис 11px великими літерами, значення 26px/300; клік — таблиця з фільтром виду. */
export function BaKindTiles({ kinds, byKind, onOpen }: IBaKindTilesProps) {
  const { t } = useTranslation();
  return (
    <div className="ba-tiles">
      {kinds.map((kind) => (
        <button key={kind} type="button" className="ba-tile" onClick={() => onOpen(kind)}>
          <span className="ba-tile__label">{t(`modBody.ba.kinds.${kind}`, { defaultValue: kind })}</span>
          <span className="ba-tile__value">{String(byKind[kind] ?? 0)}</span>
        </button>
      ))}
    </div>
  );
}
